import { hot } from 'react-hot-loader/root';
import Component from './map-redux';

export default hot(Component);
